import React, { useMemo } from 'react';
import { Box, Checkbox, FormControlLabel, Stack } from '@mui/material';
import { isLeaf } from '@mui/x-data-grid-premium';

import {
  getColumnGroupLeaves,
  isChildrenHasValue,
  useColumnPanelActions
} from '../../TableColumnServices/useColumnPanelActions';

export const ColumnGroup = ({ search, group, columnLookup, apiRef, columnVisibilityModel }) => {
  const { toggleColumn, toggleColumnGroup } = useColumnPanelActions(apiRef);

  const leaves = useMemo(() => {
    const fields = [];
    getColumnGroupLeaves(group, field => fields.push(field));

    return fields;
  }, [group]);

  const { isGroupChecked, isGroupIndeterminate } = useMemo(() => {
    return {
      isGroupChecked: leaves.every(field => columnVisibilityModel[field] !== false),
      isGroupIndeterminate:
        leaves.some(field => columnVisibilityModel[field] === false) &&
        !leaves.every(field => columnVisibilityModel[field] === false)
    };
  }, [columnVisibilityModel, leaves]);

  const filteredChildren = useMemo(() => {
    const groupIdentifier = group.groupId ?? group.headerName;

    if (groupIdentifier.toUpperCase().includes(search.toUpperCase())) {
      return group.children;
    }

    return group.children.filter(child => {
      if (isLeaf(child)) {
        const headerName = columnLookup[child.field]?.headerName ?? child.field;

        return headerName.toLowerCase().includes(search.toLowerCase());
      }

      return isChildrenHasValue(search, [child], columnLookup);
    });
  }, [group.groupId, group.headerName, group.children, search, columnLookup]);

  if (filteredChildren.length === 0) {
    return null;
  }

  return (
    <>
      <FormControlLabel
        control={<Checkbox checked={isGroupChecked} indeterminate={isGroupIndeterminate} sx={{ p: 0.5 }} />}
        label={group.headerName ?? group.groupId}
        onChange={(_, newValue) => toggleColumnGroup(newValue, group)}
      />
      <Box sx={{ pl: 3.5 }}>
        {filteredChildren.map(child => {
          return isLeaf(child) ? (
            <Stack direction="row" key={child.field}>
              <FormControlLabel
                control={<Checkbox checked={columnVisibilityModel[child.field] !== false} sx={{ p: 0.5 }} />}
                label={columnLookup[child.field]?.headerName ?? child.field}
                onChange={(_, newValue) => toggleColumn(child.field, newValue)}
              />
            </Stack>
          ) : (
            <ColumnGroup
              search={search}
              group={child}
              columnLookup={columnLookup}
              key={child.groupId}
              apiRef={apiRef}
              columnVisibilityModel={columnVisibilityModel}
            />
          );
        })}
      </Box>
    </>
  );
};
